/* global fbq */
/* global gtag */

import { useState, useRef, useEffect } from "react";
import { getDocsUpload, getRequiredDocs } from "../../Utils/api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateJourneyEvents } from "../../CustomerJourneyDetails/CustomerJourneyDetails";
import { useNavigate } from "react-router-dom";
import MobileNav from "../../component/MobileNav";
import pdfFile from '../../assets/pdf-file.png';

import JourneyRightPanel from "../../component/JourneyRightPannel";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');

  .ud-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .ud-page {
    min-height: 100vh;
    background: #eaf1fd;
    display: flex;
    flex-direction: column;
    font-family: 'Sora', sans-serif;
  }

  .ud-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top: 50px;
  }

  /* ── LEFT ── */
  .ud-left {
    display: flex;
    flex-direction: column;
    padding: 3rem 3.5rem;
    background: #eaf1fd;
    overflow-y: auto;
  }

  .ud-logo {
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 2.5rem; flex-shrink: 0;
  }
  .ud-logo-dot {
    width: 34px; height: 34px; background: #F97316;
    border-radius: 10px; display: flex; align-items: center; justify-content: center;
  }
  .ud-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .ud-logo-name { font-size: 16px; font-weight: 600; color: #0f1c2e; letter-spacing: -0.2px; }

  .ud-card {
    background: #fff;
    border-radius: 24px;
    padding: 2.25rem 2.5rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
  }

  .ud-card-title { font-size: 22px; font-weight: 700; color: #0f1c2e; letter-spacing: -0.5px; margin-bottom: 4px; }
  .ud-card-sub { font-size: 13px; color: #6b7a90; margin-bottom: 2rem; }

  /* SECTION */
  .ud-section { margin-bottom: 1.75rem; }
  .ud-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .ud-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* PROGRESS BAR */
  .ud-progress-wrap { margin-bottom: 1.5rem; }
  .ud-progress-header { display: flex; justify-content: space-between; margin-bottom: 6px; }
  .ud-progress-label { font-size: 12px; color: #6b7a90; font-weight: 500; }
  .ud-progress-count { font-size: 12px; color: #0f1c2e; font-weight: 600; }
  .ud-progress-track {
    height: 5px; background: #e0e9f5; border-radius: 99px; overflow: hidden;
  }
  .ud-progress-fill {
    height: 100%; background: #F97316; border-radius: 99px;
    transition: width 0.4s ease;
  }

  /* DOC UPLOAD ITEM */
  .ud-doc-list { display: flex; flex-direction: column; gap: 10px; }
  .ud-doc-item {
    display: flex; align-items: center; gap: 12px;
    padding: 12px 14px;
    background: #f7f9fc;
    border: 1.5px solid #dce4f0;
    border-radius: 14px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    position: relative;
    overflow: hidden;
  }
  .ud-doc-item:hover { border-color: #b8cce8; background: #fff; }
  .ud-doc-item.uploaded {
    border-color: #34d399;
    background: rgba(52,211,153,0.04);
  }

  /* preview thumbnail */
  .ud-doc-thumb {
    width: 44px; height: 44px; border-radius: 10px;
    background: #e8eef7; flex-shrink: 0;
    overflow: hidden; display: flex; align-items: center; justify-content: center;
    border: 1px solid #dce4f0;
  }
  .ud-doc-thumb img { width: 100%; height: 100%; object-fit: cover; }
  .ud-doc-thumb svg { width: 22px; height: 22px; }

  .ud-doc-info { flex: 1; min-width: 0; }
  .ud-doc-name { font-size: 13px; font-weight: 500; color: #0f1c2e; text-transform: capitalize; margin-bottom: 2px; }
  .ud-doc-hint { font-size: 11px; color: #9aaabb; }
  .ud-doc-filename { font-size: 11px; color: #34d399; font-weight: 500; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; }

  .ud-doc-action {
    flex-shrink: 0; width: 32px; height: 32px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.15s;
  }
  .ud-doc-item:not(.uploaded) .ud-doc-action { background: rgba(55,138,221,0.1); }
  .ud-doc-item.uploaded .ud-doc-action { background: rgba(52,211,153,0.12); }
  .ud-doc-action svg { width: 16px; height: 16px; }
  .ud-doc-item:not(.uploaded) .ud-doc-action svg { stroke: #378ADD; }
  .ud-doc-item.uploaded .ud-doc-action svg { stroke: #34d399; }

  

  /* CTA */
  .ud-cta {
    width: 100%; height: 50px;
    border: none; border-radius: 14px;
    background: #F97316; color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    margin-top: 1.75rem;
  }
  .ud-cta:hover:not(:disabled) { background: #ea6a0a; box-shadow: 0 6px 24px rgba(249,115,22,0.42); transform: translateY(-1px); }
  .ud-cta:active:not(:disabled) { transform: scale(0.98); }
  .ud-cta:disabled { background: #c8d3e2; box-shadow: none; cursor: not-allowed; }

  /* TRUST */
  .ud-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .ud-trust svg { width: 13px; height: 13px; }
  .ud-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* LOADING */
  .ud-loading {
    display: flex; align-items: center; gap: 10px;
    padding: 1.5rem; background: #f7f9fc; border-radius: 14px;
    color: #6b7a90; font-size: 13px;
  }
  .ud-loading-spinner {
    width: 18px; height: 18px; border: 2px solid #e0e9f5;
    border-top-color: #378ADD; border-radius: 50%;
    animation: spin 0.7s linear infinite; flex-shrink: 0;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .ud-split { grid-template-columns: 1fr; }
    .ud-left { padding: 2rem 1.25rem 6rem; }
    .ud-logo { margin-bottom: 1.5rem; }
    .ud-card { padding: 1.75rem 1.5rem; }
  }
  @media (max-width: 480px) {
    .ud-card { padding: 1.5rem 1.25rem; }
    .ud-selfie-wrap { flex-direction: column; align-items: center; }
    .ud-selfie-controls { width: 100%; }
  }
`;

// ── Icons ──
const IconBolt = () => <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconUpload = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IconCheck = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconCamera = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>;
const IconUser = () => <svg viewBox="0 0 24 24" fill="none" stroke="#9aaabb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconFile = () => <svg viewBox="0 0 24 24" fill="none" stroke="#9aaabb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IconLock = () => <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const IconCapture = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/></svg>;

const docTypeIdMap = {
  aadhaar_front: 1, aadhaar_rear: 2, pan: 4,
  utility_bill: 8, last_salary_slip: 16, selfie: 18, bank_statement: 6,
};

const isPdfDoc = (name) =>
  ["bank_statement", "last_salary_slip"].includes(
    name.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_")
  );

const getShortFileName = (fileName) => {
  if (!fileName) return "";
  const parts = fileName.split(".");
  const extension = parts.length > 1 ? "." + parts.pop() : "";
  const baseName = parts.join(".");
  return baseName.split(/[\s_-]+/)[0] + extension;
};

export default function UploadDocument() {
  const fileInputRefs = useRef({});

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [documentsRequired, setDocumentsRequired] = useState([]);
  const [isLoadingDocs, setIsLoadingDocs] = useState(false);

  const [isVerifying, setIsVerifying] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);
  const utm_source = customerDetails?.utm_source;
  const click_Id = useSelector((state) => state.customerJourneyDetails.click_id);


  

  const handleClick = (id) => {
    if (fileInputRefs.current[id]) fileInputRefs.current[id].click();
  };

 

  const handleChange = async (event, id) => {
    const file = event.target.files[0];
    if (!file) return;
    const lowerId = id.toLowerCase();
    if (lowerId.includes("salary_slip") && file.type !== "application/pdf") {
      toast.error(`${id} must be a PDF file.`);
      event.target.value = "";
      return;
    }
    const normalizedName = id.toLowerCase().replace(/\s*-\s*/g, "_").replace(/\s+/g, "_");
    const docTypeId = docTypeIdMap[normalizedName] || "";
    const formData = new FormData();
    formData.append("paySlip", file);
    formData.append("profileId", customerDetails?.profileId || "");
    formData.append("docTypeId", docTypeId);
    try {
      const resp = await getDocsUpload(formData);
      if (resp?.apiStatus === 1) {
        toast.success(`${id} uploaded successfully.`);
        setUploadedFiles((prev) => ({ ...prev, [id]: file }));
      } else {
        toast.error(`Failed to upload ${id}: ${resp?.message || "Unknown error"}`);
      }
    } catch {
      toast.error(`Size is too large for ${id}.`);
    }
  };

  

  const fetchDocuments = async () => {
    setIsLoadingDocs(true);
    try {
      const resp = await getRequiredDocs({ leadId: customerDetails?.lead_id || 0 });
      if (resp?.data?.status === 1) setDocumentsRequired(resp.data.data || []);
      else toast.error(resp?.data?.message || "Failed to fetch required documents.");
    } catch { toast.error("Failed to fetch required documents."); }
    finally { setIsLoadingDocs(false); }
  };

  useEffect(() => { fetchDocuments(); }, []);

  const getUploadedDocumentCount = () =>
    Object.entries(uploadedFiles).filter(([key, file]) => key !== "selfie" && file).length;

  const handleContinue = () => {
    if (getUploadedDocumentCount() < 2) {
      toast.error("Please upload at least 2 documents to continue.");
      return;
    }
   
    if (customerDetails?.user_type === "REPEAT") {
      dispatch(updateJourneyEvents({ upload_documents: 1, banking_details: 2 }));
    } else {
      dispatch(updateJourneyEvents({ upload_documents: 1, banking_details: 1 }));
      if (utm_source == 'Valueleaf') {
      const url = `https://pixel.whistleloop.com/pixel?click_id=${click_Id}&revenue='revenue'&goal_name=Application`;

      fetch(url).catch(() => {});
      
    }
      navigate("/journey/congratulations");
    }
  };

  const uploadedCount = getUploadedDocumentCount();
  const totalDocs = documentsRequired.length;
  const progressPct = totalDocs > 0 ? Math.round((uploadedCount / totalDocs) * 100) : 0;

  return (
    <>
      

     

      <style>{styles}</style>
      <div className="ud-page">
        <div className="ud-split">

          {/* ── LEFT: FORM ── */}
          <div className="ud-left">
            

            <div className="ud-card">
              <h1 className="ud-card-title">Upload documents</h1>
              <p className="ud-card-sub">Upload the necessary documents to move ahead with your application.</p>

              {/* PROGRESS */}
              {!isLoadingDocs && totalDocs > 0 && (
                <div className="ud-progress-wrap">
                  <div className="ud-progress-header">
                    <span className="ud-progress-label">Documents uploaded</span>
                    <span className="ud-progress-count">{uploadedCount} / {totalDocs}</span>
                  </div>
                  <div className="ud-progress-track">
                    <div className="ud-progress-fill" style={{ width: `${progressPct}%` }} />
                  </div>
                </div>
              )}

              {/* DOCUMENTS LIST */}
              <div className="ud-section">
                <div className="ud-section-title">Required documents</div>

                {isLoadingDocs ? (
                  <div className="ud-loading">
                    <div className="ud-loading-spinner" />
                    Loading required documents…
                  </div>
                ) : (
                  <div className="ud-doc-list">
                    {documentsRequired.map((doc) => {
                      const isUploaded = !!uploadedFiles[doc.name];
                      const isPdf = isPdfDoc(doc.name);
                      const thumbSrc = isUploaded
                        ? isPdf ? pdfFile : URL.createObjectURL(uploadedFiles[doc.name])
                        : null;

                      return (
                        <div
                          key={doc.id}
                          className={`ud-doc-item ${isUploaded ? 'uploaded' : ''}`}
                          onClick={() => !isUploaded && handleClick(doc.name)}
                        >
                          {/* Thumbnail */}
                          <div className="ud-doc-thumb">
                            {thumbSrc
                              ? <img src={thumbSrc} alt={doc.name} />
                              : <IconFile />
                            }
                          </div>

                          {/* Info */}
                          <div className="ud-doc-info">
                            <div className="ud-doc-name">
                              {doc.name.replace(/_/g, ' ')}
                            </div>
                            {!isUploaded && (
                              <div className="ud-doc-hint">
                                {isPdf ? 'PDF only' : 'JPG, PNG accepted'} · Max 5MB
                              </div>
                            )}
                            {isUploaded && (
                              <div className="ud-doc-filename">
                                ✓ {getShortFileName(uploadedFiles[doc.name].name)}
                              </div>
                            )}
                          </div>

                          {/* Action icon */}
                          <div className="ud-doc-action">
                            {isUploaded ? <IconCheck /> : <IconUpload />}
                          </div>

                          {/* Hidden file input */}
                          <input
                            type="file"
                            ref={(el) => (fileInputRefs.current[doc.name] = el)}
                            accept={isPdf ? "application/pdf" : "image/*"}
                            onChange={(e) => handleChange(e, doc.name)}
                            style={{ display: "none" }}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

         
              

              {/* CTA */}
              <button className="ud-cta" onClick={handleContinue} disabled={isVerifying}>
                {isVerifying ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                      </path>
                    </svg>
                    Processing…
                  </>
                ) : (
                  <>Continue </>
                )}
              </button>

              <div className="ud-trust">
                <IconLock />
                256-bit SSL encrypted
                <span className="ud-trust-sep" />
                Your data is private
                <span className="ud-trust-sep" />
                RBI compliant
              </div>
            </div>
          </div>

          {/* ── RIGHT: reusable component ── */}
          <JourneyRightPanel />

        </div>
      </div>
      <MobileNav />
    </>
  );
}